<template>
  <div class="student-course-detail">
    <div class="layout clearfix">

      <!-- 返回按钮 -->
      <navBack></navBack>

      <!-- ══════════════════════════════
           课程信息区
      ══════════════════════════════ -->
      <div class="study-course">
        <!-- 顶部装饰光效 -->
        <div class="sc-grid-bg"></div>
        <div class="sc-glow"></div>

        <div class="course-learning clearfix">
          <!-- 区块标题 -->
          <div class="section-header">
            <span class="sec-kicker">Course Overview</span>
            <h2 class="sec-title">课程学习</h2>
          </div>

          <div class="class-learn">
            <!-- 封面图 -->
            <div class="cover-img">
              <img
                v-if="course.imgUrl"
                :src="baseUrl + course.imgUrl"
                alt="课程封面"
                class="cover-photo"
              />
              <!-- 占位封面 -->
              <div v-else class="cover-fallback">
                <div class="cf-icon-wrap">
                  <i class="el-icon-film"></i>
                </div>
                <span class="cf-label">情景课程</span>
                <div class="cf-grid"></div>
              </div>
              <!-- 渐变遮罩 -->
              <div class="cover-mask"></div>
              <!-- 左下角徽章 -->
              <span class="cover-badge">情景学习</span>
            </div>

            <!-- 课程信息 -->
            <div class="abstract-info">
              <h1 class="course-title">{{ course.title || '加载中...' }}</h1>

              <!-- 标签 -->
              <div class="tag-list" v-if="course.tags && course.tags.length">
                <ul>
                  <li v-for="(tag, index) in course.tags" :key="index">{{ tag.name }}</li>
                </ul>
              </div>

              <!-- 课程描述 -->
              <p class="course-desc">{{ course.content || '本课程围绕典型情景开展案例学习、任务理解和训练复盘。' }}</p>

              <!-- 课程状态信息条 -->
              <div class="course-status-bar">
                <div class="csb-item">
                  <span class="csb-dot dot-green"></span>
                  <span class="csb-text">在线学习</span>
                </div>
                <div class="csb-sep"></div>
                <div class="csb-item">
                  <i class="el-icon-collection csb-icon"></i>
                  <span class="csb-text">情景案例</span>
                </div>
                <div class="csb-sep"></div>
                <div class="csb-item">
                  <i class="el-icon-document-checked csb-icon"></i>
                  <span class="csb-text">过程留痕</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ══════════════════════════════
           章节内容区
      ══════════════════════════════ -->
      <div class="course-content">
        <div class="section-header cc-header">
          <div>
            <span class="sec-kicker">Chapter Content</span>
            <h2 class="sec-title">课程内容</h2>
          </div>
          <span class="chapter-count-badge">共 {{ chapters.length }} 个章节</span>
        </div>

        <!-- 空状态 -->
        <div v-if="chapters.length === 0" class="chapters-empty">
          <div class="ce-icon-wrap">
            <i class="el-icon-folder-opened"></i>
          </div>
          <p>课程章节加载中，或当前课程暂无内容。</p>
        </div>

        <div class="list clearfix" v-else>
          <div class="item" v-for="(chapter, index) in chapters" :key="index">
            <ChapterCard :chapter="chapter" />
          </div>
        </div>

        <Pagination
          :total-items="totalChapters"
          :items-per-page="perPage"
          :current-page="currentPage"
          @page-changed="changePage"
        />
      </div>

    </div>
  </div>
</template>

<script>
import ChapterCard from "@/components/ChapterCard";
import Pagination from "@/components/Pagination";
import {
  getHouseList,
  getContentTags,
  getContentDetail,
  getCaseList,
} from "@/api/index";
import { mapState } from "vuex";

export default {
  name: "StudentCourseDetail",
  components: {
    ChapterCard,
    Pagination,
  },
  data() {
    return {
      contactEmail: "support@zhi119.com",
      course: {},
      chapters: [],
      totalChapters: 0,
      perPage: 10,
      currentPage: 1,
      tags: [],
      subjectId: "",
    };
  },
  mounted() {
    // 获取参数
    const urlCode = this.$route.params.id;
    this.subjectId = urlCode;

    this.fetchChapters(urlCode);
    this.fetchClassContent();
    this.getTags();
  },
  computed: {
    ...mapState(["baseUrl"]),
  },
  methods: {
    fetchChapters(urlCode) {
      getContentDetail({ urlCode })
        .then((res) => {
          if (res.code === 200) {
            this.course = res.data;
          } else {
            this.$message.error("获取课程内容失败：" + res.message);
          }
        })
        .catch((error) => {
          this.$message.error("获取课程内容失败：" + error.message);
        });
    },
    fetchClassContent() {
      getCaseList({ subjectCode: this.subjectId }).then((res) => {
        if (res && res.code == 200) {
          this.chapters = res.rows || [];
        }
      });
    },
    getTags() {
      getContentTags()
        .then((response) => {
          this.tags = response.data;
        })
        .catch((error) => {
          console.error("获取章节标签失败:", error);
        });
    },
    changePage(page) {
      this.currentPage = page;
      this.fetchChapters();
      window.scrollTo({ top: 600, behavior: "smooth" });
    },
  },
};
</script>

<style scoped lang="scss">
/* ─────────────────────────────────────────
   Design tokens
───────────────────────────────────────── */
.student-course-detail {
  --bd:      #081c42;
  --bm:      #1557d8;
  --ba:      #1e9bff;
  --cyan:    #20c8ff;
  --gray:    #475569;
  --gray-s:  #64748b;
  --card-bg: rgba(255,255,255,0.94);
  --card-bdr: rgba(168,199,245,0.68);

  min-height: 100vh;
  padding: 34px 24px 76px;
  background:
    radial-gradient(ellipse at 8% 0%, rgba(47,111,237,0.09), transparent 34%),
    radial-gradient(ellipse at 94% 3%, rgba(32,200,255,0.10), transparent 30%),
    linear-gradient(180deg, #f2f7ff 0%, #f5f7fb 48%, #ffffff 100%);
}

.layout {
  width: min(1180px, 100%);
  margin: 0 auto;
}

.clearfix::after {
  content: "";
  display: table;
  clear: both;
}

/* ─────────────────────────────────────────
   SHARED PANEL BASE
───────────────────────────────────────── */
.study-course,
.course-content {
  overflow: hidden;
  border-radius: 22px;
  background: var(--card-bg);
  border: 1px solid var(--card-bdr);
  box-shadow: 0 14px 38px rgba(8,28,66,0.08);
}
.study-course { margin-bottom: 20px; position: relative; }

/* ─────────────────────────────────────────
   COURSE LEARNING HERO
───────────────────────────────────────── */
/* Background decorations inside the study-course panel */
.sc-grid-bg {
  position: absolute;
  inset: 0;
  opacity: 0.34;
  background-image:
    linear-gradient(rgba(21,87,216,0.08) 1px, transparent 1px),
    linear-gradient(90deg, rgba(21,87,216,0.08) 1px, transparent 1px);
  background-size: 40px 40px;
  mask-image: linear-gradient(180deg, rgba(0,0,0,0.7), transparent 80%);
  pointer-events: none;
}
.sc-glow {
  position: absolute;
  right: -60px; top: -60px;
  width: 200px; height: 200px;
  border-radius: 50%;
  background: rgba(32,200,255,0.10);
  filter: blur(14px);
  pointer-events: none;
}

.course-learning {
  position: relative;
  z-index: 1;
  padding: 24px;
}

/* Section header (shared) */
.section-header {
  margin-bottom: 20px;
}
.sec-kicker {
  display: inline-block;
  color: var(--ba);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.5px;
  margin-bottom: 5px;
}
.sec-title {
  margin: 0;
  color: var(--bd);
  font-size: 20px;
  font-weight: 950;
  line-height: 1.2;
}
.cc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(168,199,245,0.4);
  margin-bottom: 20px;
}
.chapter-count-badge {
  padding: 4px 11px;
  border-radius: 999px;
  background: rgba(21,87,216,0.07);
  border: 1px solid rgba(21,87,216,0.14);
  color: var(--bm);
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Content grid */
.class-learn {
  display: grid;
  grid-template-columns: 360px 1fr;
  gap: 26px;
  align-items: start;
}

/* Cover image */
.cover-img {
  position: relative;
  width: 100%;
  height: 220px;
  overflow: hidden;
  border-radius: 18px;
  background: linear-gradient(135deg, #e8f0fc, #f4f8ff);
  border: 1px solid var(--card-bdr);
}
.cover-photo {
  width: 100%; height: 100%;
  object-fit: cover;
  display: block;
}
/* premium fallback */
.cover-fallback {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  overflow: hidden;
}
.cf-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(21,87,216,0.09) 1px, transparent 1px),
    linear-gradient(90deg, rgba(21,87,216,0.09) 1px, transparent 1px);
  background-size: 22px 22px;
  pointer-events: none;
}
.cf-icon-wrap {
  position: relative;
  z-index: 1;
  width: 58px; height: 58px;
  border-radius: 18px;
  display: grid;
  place-items: center;
  background: linear-gradient(145deg, rgba(21,87,216,0.12), rgba(32,200,255,0.16));
  border: 1px solid rgba(21,87,216,0.16);
  color: var(--bm);
  font-size: 26px;
  box-shadow: 0 10px 24px rgba(21,87,216,0.13);
}
.cf-label {
  position: relative;
  z-index: 1;
  font-size: 13px;
  font-weight: 800;
  color: var(--bm);
  letter-spacing: 0.5px;
}
/* gradient overlay on cover */
.cover-mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, transparent 50%, rgba(8,20,52,0.32));
  pointer-events: none;
}
.cover-badge {
  position: absolute;
  z-index: 2;
  left: 12px; bottom: 12px;
  padding: 4px 9px;
  border-radius: 999px;
  color: #fff;
  background: rgba(18,72,200,0.88);
  border: 1px solid rgba(255,255,255,0.14);
  backdrop-filter: blur(8px);
  font-size: 11px;
  font-weight: 800;
}

/* Abstract info */
.abstract-info { min-width: 0; }

.course-title {
  margin: 0 0 12px;
  color: var(--bd);
  font-size: 24px;
  line-height: 1.3;
  font-weight: 950;
  letter-spacing: -0.3px;
}

.tag-list ul {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  list-style: none;
  margin: 0 0 14px;
  padding: 0;
}
.tag-list li {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(21,87,216,0.08);
  border: 1px solid rgba(21,87,216,0.14);
  color: var(--bm);
  font-size: 12px;
  font-weight: 800;
}

.course-desc {
  color: var(--gray);
  font-size: 14px;
  line-height: 1.82;
  margin: 0 0 18px;
}

/* Status bar */
.course-status-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 12px;
  background: rgba(248,251,255,0.9);
  border: 1px solid rgba(168,199,245,0.5);
}
.csb-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 800;
  color: var(--gray-s);
}
.csb-dot { width: 7px; height: 7px; border-radius: 50%; }
.dot-green { background: #4ade80; box-shadow: 0 0 6px rgba(74,222,128,0.8); }
.csb-icon { color: var(--ba); font-size: 14px; }
.csb-text { color: var(--gray-s); }
.csb-sep { width: 1px; height: 18px; background: rgba(168,199,245,0.6); }

/* ─────────────────────────────────────────
   CHAPTER CONTENT AREA
───────────────────────────────────────── */
.course-content { padding: 24px; }

.list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 18px;
  margin-bottom: 28px;
}
.item { min-height: 100%; }

/* Empty state */
.chapters-empty {
  min-height: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px;
  border-radius: 16px;
  background: rgba(248,251,255,0.9);
  border: 1px dashed rgba(21,87,216,0.18);
  margin-bottom: 20px;
  text-align: center;
}
.ce-icon-wrap {
  width: 50px; height: 50px;
  border-radius: 16px;
  display: grid;
  place-items: center;
  background: linear-gradient(145deg, rgba(21,87,216,0.10), rgba(32,200,255,0.12));
  color: var(--ba);
  font-size: 22px;
}
.chapters-empty p { color: var(--gray-s); font-size: 13px; line-height: 1.72; }

/* ─────────────────────────────────────────
   RESPONSIVE
───────────────────────────────────────── */
@media (max-width: 860px) {
  .class-learn { grid-template-columns: 1fr; }
  .student-course-detail { padding: 24px 16px 56px; }
  .course-learning, .course-content { padding: 20px; }
  .cover-img { height: 200px; }
}
@media (max-width: 540px) {
  .list { grid-template-columns: 1fr; }
  .course-status-bar { flex-wrap: wrap; gap: 8px; }
}
</style>
